import { render, staticRenderFns } from "./ApptCall.vue?vue&type=template&id=8cdafeb8"
import script from "./ApptCall.vue?vue&type=script&lang=js"
export * from "./ApptCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports